const isDev = process.env.REACT_APP_STAGE !== 'prod';

export const logger = {
  log: (...args: any[]) => isDev && console.log(...args),
  debug: (...args: any[]) => isDev && console.debug(...args),
  warn: (...args: any[]) => isDev && console.warn(...args),
  error: (...args: any[]) => isDev && console.error(...args),
};
